import axios from 'axios';
import map from 'lodash.map';
import find from 'lodash.find';
import assign from 'lodash.assign';
import orderBy from 'lodash.orderby';
import { lSportsConfig } from '../../config';
import EventEmitter from '../../helper/EventEmitter';

class lSportsService extends EventEmitter {
    enablePackage = () => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.EnablePackage, {
                    params: {
                        username: lSportsConfig.account.prematch.username,
                        password: lSportsConfig.account.prematch.password,
                        guid: lSportsConfig.account.prematch.guid,
                        packageid: lSportsConfig.account.prematch.packageID,
                    },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    getSports = (lang) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.GetSports, {
                    params: {
                        username: lSportsConfig.account.prematch.username,
                        password: lSportsConfig.account.prematch.password,
                        guid: lSportsConfig.account.prematch.guid,
                        lang: lang,
                    },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    getLocations = (lang) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.GetLocations, {
                    params: {
                        username: lSportsConfig.account.prematch.username,
                        password: lSportsConfig.account.prematch.password,
                        guid: lSportsConfig.account.prematch.guid,
                        lang: lang,
                    },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    getEvents = (lang) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.GetEvents, {
                    params: {
                        username: lSportsConfig.account.prematch.username,
                        password: lSportsConfig.account.prematch.password,
                        guid: lSportsConfig.account.prematch.guid,
                        lang: lang,
                        sports: lSportsConfig.filter.events.sports,
                        locations: lSportsConfig.filter.events.locations,
                        markets: lSportsConfig.filter.events.markets,
                    },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    fetchEvents = (lang) => {
        return new Promise((resolve, reject) => {
            fetch('http://lsports.melkonian.nl/data/prematch/getevents.json')
                .then((response) => response.json())
                .then((data) => resolve(data));
        });
    };

    getEventsBySport = (lang, sportId) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.GetEvents, {
                    params: {
                        username: lSportsConfig.account.prematch.username,
                        password: lSportsConfig.account.prematch.password,
                        guid: lSportsConfig.account.prematch.guid,
                        lang: lang,
                        sports: sportId,
                        locations: lSportsConfig.filter.events.locations,
                        markets: lSportsConfig.filter.events.markets,
                    },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    getEventsBySportAndLocation = (lang, sportId, locationId) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.GetEvents, {
                    params: {
                        username: lSportsConfig.account.prematch.username,
                        password: lSportsConfig.account.prematch.password,
                        guid: lSportsConfig.account.prematch.guid,
                        lang: lang,
                        sports: sportId,
                        locations: locationId,
                        markets: lSportsConfig.filter.events.markets,
                    },
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    assignLocationSort = (locationObject, sportId) => {
        let sport = find(lSportsConfig.sort.location, (i) => {
            return i.SportId === sportId;
        });

        let location = null;

        if (sport) {
            location = find(sport.Locations, (i) => {
                return i.Id === locationObject.Id;
            });
        }

        return location
            ? assign(locationObject, location)
            : assign(locationObject, {
                  Id: locationObject.Id,
                  Sort: locationObject.Id,
              });
    };

    assignSportSort = (sportObject) => {
        let sport = find(lSportsConfig.sort.sport, (i) => {
            return i.Id === sportObject.Id;
        });

        return sport
            ? assign(sportObject, sport)
            : assign(sportObject, {
                  Id: sportObject.Id,
                  Sort: sportObject.Id,
              });
    };

    orderByEvents = (events) => {
        events = map(events, (e) => {
            e.Locations = map(e.Locations, (l) => {
                return this.assignLocationSort(l, e.Id);
            });
            e.Locations = orderBy(e.Locations, ['Sort'], 'dec');
            return this.assignSportSort(e);
        });

        return orderBy(events, ['Sort'], 'dec');
    };

    prematchGetLeagueEvents = (sportId, locationId, leagueId) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.prematch.getLeagueEvents + '/' + sportId + '/' + locationId + '/' + leagueId)
                .then((response) => {
                    //let events = this.orderByEvents(response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    prematchGetEvents = (pullAll) => {
        let url = lSportsConfig.routes.prematch.getEvents + '/' + pullAll;
        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then((response) => {
                    let events = this.orderByEvents(response.data);
                    resolve(events);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    inplayGetLeagueEvents = (sportId, locationId, leagueId) => {
        return new Promise((resolve, reject) => {
            axios
                .get(lSportsConfig.routes.inplay.getLeagueEvents + '/' + sportId + '/' + locationId + '/' + leagueId)
                .then((response) => {
                    //let events = this.orderByEvents(response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    //InPlay
    inPlayGetEvents = (pullAll) => {
        let url = lSportsConfig.routes.inplay.getEvents + '/' + pullAll;

        return new Promise((resolve, reject) => {
            axios
                .get(url)
                .then((response) => {
                    let events = this.orderByEvents(response.data);
                    resolve(events);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
}

const instance = new lSportsService();

export default instance;
